import { ccfRoutes } from '@app/ccf/ccf-routes';
import GuideLayout from '@shared/components/guide-layout';
import { generatePath, useParams } from 'react-router-dom';
import { getScope1And2CategoryRoute, getScope1And2Config } from './config';

/**
 * Full-screen layout for the Scope 1 & 2 import flow (process info → upload).
 * Closing returns the user to the category page they launched from.
 */
export default function Scope1And2ImportLayout() {
  const { report_uuid, category_slug } = useParams();
  const config = getScope1And2Config(category_slug);

  const onClosePath = config
    ? generatePath(getScope1And2CategoryRoute(config.slug), { report_uuid })
    : generatePath(ccfRoutes.COMPANY_REPORT, { report_uuid });

  return (
    <GuideLayout
      pageName="Scope 1 & 2 import"
      onClosePath={onClosePath}
      className="from-primary-300 to-primary-100"
    />
  );
}
